<template>
  <div class="selectInput">
 <div class="title">
    <input type="text" placeholder="please choose.." class="form-control" :class="{'checkinput': isShow}" onfocus="this.blur()" v-model="selectCon" @click.stop="liShow" />
      <i class="fa fa-angle-down" style="font-weight:bold;color:black" @click.stop="liShow"></i>
    </div>
    <ul v-show="isShow" @click.stop="liShow">
      <li v-for="item in liData" :key="item.Id" @click.stop="lichoose(item)">
          {{item.Id +":"+item.Name}}
      </li>
    </ul>
    </div>
</template>




 
<script>
import _ from 'lodash'
export default {
name: "selectInput",  
data() {
    return {
      checkedData: [], //选中的数据
      isShow: false, //下拉列表是否显示
      selectCon: "", //选中的内容
      selectId:"",
      selectName:""
    };
  },
  props: ["liData", "replyName"],

  mounted() {
    let that = this;
    //点击页面空白处隐藏下拉列表
    document.addEventListener("click", function() {
      that.isShow = false;
    });
  },

   watch: {
    liData: {
      handler(newVal, oldVal) {
        //选中数据
        this.checkedData = newVal.filter(function(item) {
          return item.Check == true;
        });
        //在页面打印出的数据
        this.selectCon = ""; //点击的当前项的展示
        this.selectId  = "";
        var  seletct=[];
        var  seletctName=[];
        for (var i = 0; i < this.checkedData.length; i++) {
          this.selectCon += this.checkedData[i].Name + "  ";
          seletct.push(this.checkedData[i].Id)
          seletctName.push(this.checkedData[i].Name)
        }

        this.selectId = seletct.toString()
        this.selectName = seletctName.toString()
        // 给父组件传值
        if(this.replyName == true)
          this.$emit("change", this.selectName);
        else
          this.$emit("change", this.selectId);
      },
      deep: true
    }
  },

  methods: {
    //控制下拉列表的显示隐藏
    liShow() {
      console.log(this.isShow)
      this.isShow = !this.isShow;
    },

    lichoose(item) {
      this.$set(item, 'Check', !item.Check)
    }
  }


}
</script>

<style scoped>
.selectInput .title {
  position: relative;
}

.selectInput i {
  position: absolute;
  width: 30px;
  height: 40px;
  line-height: 38px;
  right: -5px;
  top: 1px;
  text-align: center;
  cursor: pointer;
}
.selectInput ul {
  border-radius: 3px;
  -moz-border-radius: 3px; /* Firefox */
  -webkit-border-radius: 3px; /* Safari 和 Chrome */
  border-radius: 3px; /* Opera 10.5+, 以及使用了IE-CSS3的IE浏览器 */
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2); /* Firefox */
  -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2); /* Safari 和 Chrome */
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2); /* Opera 10.5+, 以及使用了IE-CSS3的IE浏览器 */
  /* border: 1px solid #ccc; */
  padding: 10px 10px;
  height: 100px;
  overflow: auto;
}
.selectInput li {
  line-height: 15px;
  list-style-type:none;
}

.selectInput ul :hover {
  background-color: rgb(0, 140, 255);
  color: white;
  width: 100%;
}

.checkinput{
  border-color:#008B8B;
  outline:0;
  -webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(0,139,139,.6);
  box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(0,139,139,.6);
}


</style>